export default __webpack_public_path__ + "static/media/PRHP.1b204450.png";